import axios from "axios";

axios.defaults.withCredentials = false;

export default axios;
